import React, { useContext } from 'react';
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../ui-styles/cards/Prescription.css";
import "../../../ui-styles/prescription/prescriptionAdd.css"
import "../../../ui-styles/sliders/RightChildSlider.css";
// import Button from "../../../lib/ui/buttons/Button";
import { LangCtx } from "../../../lib/context";

const PreviewTemplate = (props) => {
    const { l } = useContext(LangCtx);
    const { data } = props;
    const backgroundColor = {
        backgroundColor: '#2b80c4'
    }
    const footerColor = {
        backgroundColor:'#24a4c4'
    }

    let header = null, footer = null, sign = null;

    if (data && data.length > 0) {
        for (let i in data) {
            let item = data[i];
            switch (item.uploadtype) {
                case "header": header = item;
                    break;
                case "signature": sign = item;
                    break;
                case "footer": footer = item;
                    break;
                default: break;
            }
        }
    }

    return  <div className={props.open ? "rightChildSlider childSliderIn" : "rightChildSlider"}>
                <div className="rightSliderHdr">
                    <div className="hdrRowBlock">
                        <div className="hdrTitleBox">
                            <span>{l.preview}</span>
                        </div>
                        <div className="hdrActionGroup" onClick={props.handleClose}>
                            <div className="hdrActItem close"></div>
                        </div>
                    </div>
                </div>

                <div className="rightSliderBdy height100">
                    <div className="prescriptionCard">
                        {/* <div className="presCardHdr">
                            <div className="presDate">
                                <span>Mon, 12Mar, 2020</span>
                            </div>
                            <Button
                                label={l.print}
                                size="sm"
                                type="outLine"
                                onClick=""
                            />
                        </div>*/}

                        <div className="presCardBdy">
                            {/* <div className="presBranding" style={backgroundColor} >
                                {header ?
                                    <img src={header.uploadurl} alt="logo" /> :
                                    <img src="/images/logos/inclinix-logo.png" className="invertWhite" alt="logo" />}
                            </div> */}
                            {header ?
                            <div className="prevPrescHdrBanner">
                                <div className="prevPrescHdr">
                                    <div className="prevPrescBranding prescHdFooter">
                                        <img src={header.uploadurl} alt="logo" />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="presBranding" style={backgroundColor} >
                                <img src="/images/logos/inclinix-logo.png" className="invertWhite" alt="logo" />
                            </div>
                            }


                            <div className="prescDetailItem">
                                <div className="presDtlBlock">
                                    <span className="presTxtL">{l.pat_name} <small>Carla Houston</small></span>
                                    <span className="presTxtL">{l.pat_age} <small>24 Years</small></span>
                                    <span className="presTxtL">{l.pat_gender} <small>Female</small></span>
                                    <span className="presTxtL">{l.upload_date} <small>12/10/2020</small></span>
                                </div>
                                <div className="presDtlBlock txtRight">
                                    <span className="presTxtL"><small>Dr. Doctor Name</small></span>
                                    <span className="presTxtL">Children Specialist<small></small></span>
                                    <span className="presTxtL">DC,</span>
                                </div>
                            </div>
                            <div className="prescDetailItem">
                                <div className="presDtlBlock">
                                    <span className="presTxtL">{l.reas_for_call}: <small> Cough</small></span>
                                    <span className="presTxtL">{l.det_by_pat}: <small>Fever and Cough since 3 days</small></span>
                                </div>
                            </div>
                            <div className="prescDetailItem">
                                <div className="presDtlBlock">
                                    <span className="presTxtL">{l.chief_comp}:</span>
                                    <span className="presTxtL"><small>Body Ache, Dry Cough &amp; Fever</small></span>
                                </div>
                                <div className="presDtlBlock">
                                    <span className="presTxtL">{l.diagnosis}:</span>
                                    <span className="presTxtL"><small>Dengue Fever</small></span>
                                </div>
                            </div>
                            <div className="prescDetailItem">
                                <div className="presDtlBlock">
                                    <span className="presTxtL">{l.investigation}:</span>
                                    <span className="presTxtL"><small>Blood Test &amp; CBC report</small></span>
                                </div>
                                <div className="presDtlBlock">
                                    <span className="presTxtL">{l.remarks}:</span>
                                    <span className="presTxtL"><small>Dengue Fever</small></span>
                                </div>
                            </div>

                            <div className="presMedGroup">
                                <div className="prescTableWrapper">
                                    <table className="prescTable">
                                        <thead>
                                            <tr>
                                                <th>{l.s_no}</th>
                                                <th>{l.drug_name}</th>
                                                <th>{l.qtyd}</th>
                                                <th>{l.schedule}</th>
                                                <th>{l.note}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Cureveda Stress Shield</td>
                                                <td>4 mg</td>
                                                <td>Morning-Evening (After Meal) </td>
                                                <td>make notes visible here</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Rocin - 500</td>
                                                <td>5 tab's</td>
                                                <td>Morning-Evening (After Meal) </td>
                                                <td>with honey</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {/* FOOTER */}
                        <div className="prescMedFooter">
                            <div className="signatureCol">
                                <div className="signatureBox">
                                    <span className="docLTxt">Dr.Purnima Rao</span>
                                    <span className="docSTxt">MD (AY) - 10 Years</span>
                                    <div className="signatureIcon">
                                        {sign ? <img src={sign.uploadurl} alt="logo" /> :
                                            <img src="/images/icons/signature.png" className="invertBlack" alt="logo" />}
                                    </div>
                                </div>
                            </div>
                            <div className="prevPrescFooter">
                                    {footer ?
                                    <div className="prevPrescBranding prescHdFooter">
                                        <img src={footer.uploadurl} alt="logo" />
                                    </div>
                                    :
                                    <div className="prevPrescBranding prescHdFooter" style={footerColor}>
                                        <img src="/images/logos/presc-footer.png" alt="logo" />
                                    </div>
                                    }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

export default PreviewTemplate;